import { PackagingSelectionItem } from "~/domains/product/components/PackagingSelection/PackagingSelectionItem";
import type { PackagingOption } from "~/domains/product/types/PackagingOption";

import { styled, Stack } from "~/common/mui";

export interface Props {
  className?: string;
  value: string;
  onChange?: (packCode: string) => void;
  options: PackagingOption[];
  initiallyExpanded?: false | "item" | "full";
  disabled?: boolean;
}

const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const PackagingSelection = ({
  options,
  className,
  onChange,
  value,
  initiallyExpanded = "full",
  disabled,
}: Props) => {
  if (!options.length) {
    return null;
  }

  return (
    <Root className={className}>
      {options.map((pack) => {
        const displayedPack =
          pack.predecessors.length > 1 ? { ...pack, predecessors: pack.predecessors.slice(0, 1) } : pack;

        return (
          <PackagingSelectionItem
            key={pack.packCode}
            onSelect={onChange ? () => onChange(pack.packCode) : undefined}
            selected={value === pack.packCode}
            pack={displayedPack}
            disabled={disabled}
            initiallyExpanded={value === pack.packCode ? initiallyExpanded : false}
          />
        );
      })}
    </Root>
  );
};
